var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelBlogSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M12 10V2.009A2.01 2.01 0 0 0 9.991 0H2.01A2.01 2.01 0 0 0 0 2.009V10zm-.272 1a2.01 2.01 0 0 1-1.737 1H2.01a2.01 2.01 0 0 1-1.737-1zM0 9V8h12v1zm0-2V6h12v1z"
})));
export default SvgChannelBlogSm;